import React from 'react'
import styles from './Style.module.css'

export const BtnPrimaryWithIcon = ({label, handleClick, disabled, icon, customClass, variant, secondaryIcon}) => {
  return (
    <button 
      className={`${styles.Btn} ${styles.BtnPrimary} btn ${customClass} ${variant ? styles[variant] : ''}`}
      onClick={handleClick} 
      disabled={disabled}
      title={label}
    >
      <span className={`${styles.icon} ${styles.preIcon}`}>{icon}</span>
      <span className={styles.text}>{label}</span>
      <span className={`${styles.icon} ${styles.postIcon}`}>{secondaryIcon}</span>
    </button>
  )
}
